export default "__VITE_ASSET__BBCHSnMj__"